const attestationUrls = {
    fetchResources: {
        url: '/attestation/resource/'
    },
    fetchResource: {
        url: '/attestation/resource/:id'
    },
};

export default attestationUrls;
